import OnboardingSmsModal from './onboarding-sms-modal';

export default OnboardingSmsModal;
